<div class="item-grid-container px-3">
    <div class="row consumerDetail">
        <div class="col-lg-4 consumerdetailSection" >
          <mat-label>{{'pages.newRetailer.firstName' |translate}} :</mat-label>
          <p class="consumerdetailSectionValue">{{consumerDetails?.firstName}}</p>
          </div>
          <div class="col-lg-4 consumerdetailSection">
          <mat-label>{{ 'pages.newRetailer.lastName' | translate}} :</mat-label>
          <p class="consumerdetailSectionValue">{{consumerDetails?.lastName}}</p>
          </div>
          <div class="col-lg-4 consumerdetailSection">
            <mat-label>{{ 'pages.newRetailer.mobileNumber' | translate}} :</mat-label>
            <p class="consumerdetailSectionValue">{{consumerDetails?.mobileNumber}}</p>
      </div>
  </div>
  
    <ul class="list-inline grid-top-actions search-holder mb-3">
      <li class="list-inline-item">
        <div class="form-item-input search-dropdown">
          <mat-label>{{'pages.ManageConsumer.LoyaltyPointsModifiedIn' | translate}} </mat-label>
          <mat-form-field appearance="outline" class=" p-0 m-0">
            <mat-select
              [(value)]="selectedDays"
              name="pricelist"
              (selectionChange)="changehistory($event)"
            >
            <!-- (selectionChange)="changehistory($event)" -->
              <mat-option
                [value]="dayCount.days"
                *ngFor="let dayCount of historyDays"
              >
                {{ dayCount.value }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </li>
      <li class="list-inline-item float-end">
        <button
          mat-stroked-button
          color="primary"
          class=""
          (click)="exportData()"
        >
          <span translate class="translate">pages.newRetailer.download</span>
          <i class="mi mi-save-alt"></i>
        </button>
      </li>
    </ul>
    <div class="report-grid">
      <ag-grid-angular
        style="width: 100%; height: 65vh"
        class="ag-theme-material"
        [rowHeight]="40"
        [enableFilter]="true"
        [enableSorting]="true"
        [enableColResize]="true"
        [rowSelection]="'single'"
        [rowData]="rowData"
        (gridReady)="onGridReady($event)"
        [columnDefs]="columnDefs"
      >
      </ag-grid-angular>
    </div>
  </div>